import React from "react";
import { DialogTitle, Box, Typography, DialogContent, DialogActions } from "@mui/material";
import { IconButton, Button } from "../button/Buttons.js";
import "../button/EditButton.js";
import { ErrorAccordion } from "../error/ErrorAccordion.js";
import "../error/ErrorDetails.js";
import "../error/localize.js";
import "../error/ErrorModal.js";
import "react-intl";
import "../error/GlobalServerErrorMessage.js";
import "../icons/Icon.js";
import { CustomIcon } from "../icons/types.js";
import "../icons/ExpandMoreIcon.js";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import { withTraceErrorBoundary } from "../../otel/TraceErrorBoundary.js";
import "rxjs/operators";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import { useModalClasses } from "./Modal.style.js";
function ModalContentInternal(props) {
  const { dialogContentClassName, title, subtitle, body, buttons, description, footer, subInfoMessage, onCloseClick } = props;
  const { classes: modalClasses } = useModalClasses();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(DialogTitle, { classes: { root: modalClasses.modalTitle } }, /* @__PURE__ */ React.createElement(Box, { className: modalClasses.modalTitleText }, title, /* @__PURE__ */ React.createElement(Box, { className: modalClasses.modalSubtitle }, /* @__PURE__ */ React.createElement(Typography, { variant: "body1", color: "secondary" }, subtitle))), /* @__PURE__ */ React.createElement(
    IconButton,
    {
      "aria-label": "close",
      className: modalClasses.modalCloseButton,
      disableFocusRipple: true,
      disableTouchRipple: true,
      disableRipple: true,
      onClick: onCloseClick
    },
    /* @__PURE__ */ React.createElement(Box, { component: "span", className: CustomIcon.CancelOutline, fontSize: 10 })
  )), /* @__PURE__ */ React.createElement(
    DialogContent,
    {
      className: `${dialogContentClassName} ${modalClasses.modalContent} ${!title ? modalClasses.modalContentNoTitle : ""}`
    },
    description,
    body
  ), buttons?.length > 0 ? /* @__PURE__ */ React.createElement(DialogActions, { className: modalClasses.modalActions }, /* @__PURE__ */ React.createElement(Box, { className: modalClasses.modalSubInfoMessageContainer }, subInfoMessage), /* @__PURE__ */ React.createElement(Box, { className: modalClasses.modalActionsButtonsContainer }, buttons.map((button, index) => {
    return button ? /* @__PURE__ */ React.createElement(
      Button,
      {
        key: button.id ?? index,
        color: button.isPrimary ? "primary" : "secondary",
        label: button.label,
        onClick: button.onClick,
        disabled: button.disabled,
        "data-testid": button.id
      }
    ) : null;
  }))) : null, footer ? /* @__PURE__ */ React.createElement(DialogActions, { className: modalClasses.modalActions }, footer) : /* @__PURE__ */ React.createElement(React.Fragment, null));
}
const ModalContent = withTraceErrorBoundary(ModalContentInternal, ErrorAccordion);
export {
  ModalContent
};
//# sourceMappingURL=ModalContent.js.map
